import { createCrudPage } from './factories/crud-page.js';

export default createCrudPage({
  title: 'Banner Clients',
  basePath: '/banners-clients',
  columns: [
    { key: 'company', label: 'Company', sortable: true },
  ],
  fields: [
    { key: 'company', label: 'Company', type: 'text', required: true },
  ],
  rowActions: [{ key: 'edit', label: 'Edit' }],
  defaultSort: { field: 'company', dir: 'asc' },
});
